.wrapper {
  flex-direction: column;
  .loader {
    display: none;
  }
  &.is-loading {
    .loader {
      display: block;
    }
    .content {
      display: none;
    }
  }
}

.d-none {
  display: none;
}

gz-input-search#views-input-search {
  padding-left: calc(var(--spacer) * 2);
}

.categories {
  flex: 2;

  .accordion-slot {
    width: calc(100% - 26px);
  }
  .accordion-title .accordion-count {
    padding-left: calc(var(--spacer) / 2);
  }

  .accordion-title {
    text-transform: uppercase;
    font-size: var(--body-size-small);
    font-weight: 600;
  }

  .accordion-title,
  .accordion-count {
    color: var(--chart-300-icon-buttons);
    width: auto;
  }

  .accordion-count {
    padding-left: calc(var(--spacer) / 2);
  }
}

gz-list-item {
  padding-left: calc(var(--spacer) * 2);
  color: var(--main-titles-inputs-600);
  font-weight: 200;
  font-size: var(--body-size-large);
}

gz-accordion {
  padding-top: calc(var(--spacer) * 2);
  --margin--compact-accordion: 0;
  &::part(accordionHeader) {
    padding-left: calc(var(--spacer) * 2);
  }
}

.no-items {
  padding-left: calc(var(--spacer) * 2);
  font-size: var(--body-size);
  margin-top: calc(var(--spacer) * 2);
  text-align: center;
  color: var(--main-titles-inputs-600);
}
